var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAakash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.5498C0 5.02696 4.47715 0.549805 10 0.549805H38C43.5229 0.549805 48 5.02696 48 10.5498V38.5498C48 44.0727 43.5228 48.5498 38 48.5498H10C4.47715 48.5498 0 44.0727 0 38.5498V10.5498Z",
    fill: "url(#paint0_linear_4168_5959)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4188 23.4712C33.5978 23.3922 33.7498 23.2625 33.8558 23.098C33.9617 22.9335 34.0172 22.7416 34.0151 22.5459C34.0131 22.3503 33.9537 22.1595 33.8444 21.9973C33.735 21.835 33.5804 21.7084 33.3998 21.6332L24.8288 17.7292C24.5683 17.6103 24.2852 17.5488 23.9988 17.5488C23.7124 17.5488 23.4294 17.6103 23.1688 17.7292L14.5988 21.6292C14.4208 21.7072 14.2693 21.8353 14.163 21.998C14.0566 22.1607 14 22.3508 14 22.5452C14 22.7395 14.0566 22.9297 14.163 23.0924C14.2693 23.255 14.4208 23.3832 14.5988 23.4612L23.1688 27.3692C23.4294 27.488 23.7124 27.5495 23.9988 27.5495C24.2852 27.5495 24.5683 27.488 24.8288 27.3692L33.4188 23.4712Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 22.5508V28.5508",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 25.0508V28.5508C18 29.3464 18.6321 30.1095 19.7574 30.6721C20.8826 31.2347 22.4087 31.5508 24 31.5508C25.5913 31.5508 27.1174 31.2347 28.2426 30.6721C29.3679 30.1095 30 29.3464 30 28.5508V25.0508",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4168_5959",
    x1: 24,
    y1: 0.549805,
    x2: 24,
    y2: 48.5498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#155DFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60A5FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAakash);
export default __webpack_public_path__ + "static/media/Aakash.1e3644646948d741a3c55602a2fe0de0.svg";
export { ForwardRef as ReactComponent };